import {createFeatureFlagsStore} from '#imports';

export const useFeatureFlagsStoreUnlogged = createFeatureFlagsStore(
    ['one-entry-point-improvements-unlogged-homepage', 'enable-auth-link'],
    'navbar-module-feature-flags',
);
